var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.11763V19.2353C24 20.4048 23.0519 21.3529 21.8824 21.3529H2.11763C0.948094 21.3529 0 20.4048 0 19.2353V5.11763C0 3.94809 0.948094 3 2.11763 3H21.8823C23.0519 2.99995 24 3.94805 24 5.11763ZM7.05881 4.41174V19.9411H11.2941V4.41174H7.05881ZM1.41178 8.64704V11.4706H5.64708V8.64704H1.41178ZM5.64708 4.41174H2.11767C1.72781 4.41174 1.41178 4.72777 1.41178 5.11763V7.2353H5.64708V4.41174ZM1.41178 12.8823V15.7058H5.64708V12.8823H1.41178ZM1.41178 17.1176V19.2353C1.41178 19.6252 1.72781 19.9412 2.11767 19.9412H5.64708V17.1177L1.41178 17.1176ZM12.7059 8.64704V11.4706H16.9412V8.64704H12.7059ZM12.7059 4.41174V7.23525H16.9412V4.41174H12.7059ZM12.7059 12.8823V15.7058H16.9412V12.8823H12.7059ZM12.7059 17.1176V19.9411H16.9412V17.1176H12.7059ZM18.3529 8.64704V11.4706H22.5882V8.64704H18.3529ZM18.3529 4.41174V7.23525H22.5882V5.11758C22.5882 4.72772 22.2722 4.41169 21.8823 4.41169L18.3529 4.41174ZM18.3529 12.8823V15.7058H22.5882V12.8823H18.3529ZM18.3529 17.1176V19.9411H21.8823C22.2722 19.9411 22.5882 19.6251 22.5882 19.2353V17.1176L18.3529 17.1176Z",
    fill: "#776F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnChange);
export default __webpack_public_path__ + "static/media/ColumnChange.d848a7edfdb7b972eb9ce0bc8ec366c3.svg";
export { ForwardRef as ReactComponent };